import React from "react";
import { Check, Clock, Truck, Calendar, CheckCircle2 } from "lucide-react";

const STAGES = [
  { key: "ordered", label: "Ordered", icon: Check, desc: "Order received" },
  { key: "in_process", label: "In Process", icon: Clock, desc: "Being prepared" },
  { key: "awaiting_arrival", label: "Awaiting Arrival", icon: Truck, desc: "Products in transit" },
  { key: "scheduling", label: "Scheduling", icon: Calendar, desc: "Coordinating install" },
  { key: "scheduled", label: "Scheduled", icon: Calendar, desc: "Install date set" },
  { key: "installed", label: "Installed", icon: CheckCircle2, desc: "Installation complete" },
  { key: "completed", label: "Completed", icon: CheckCircle2, desc: "All done" },
];

const STAGE_INDEX = (status) => STAGES.findIndex((s) => s.key === status);

export default function StatusTimeline({ status, timeline = [] }) {
  const currentIdx = STAGE_INDEX(status);
  return (
    <div className="space-y-5" data-testid="status-timeline">
      {STAGES.slice(0, 7).map((stage, idx) => {
        const isComplete = idx <= currentIdx;
        const isCurrent = idx === currentIdx;
        const event = timeline.find((t) => t.status === stage.key);
        return (
          <div key={stage.key} className={`flex items-start gap-4 ${idx < STAGES.length - 1 ? "pb-2" : ""}`}>
            <div className="relative flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full grid place-items-center shrink-0 transition-all ${
                  isComplete
                    ? isCurrent
                      ? "bg-[#C9A356] text-white pulse-gold"
                      : "bg-[#0A2540] text-white"
                    : "bg-slate-100 text-slate-400 border border-slate-200"
                }`}
              >
                <stage.icon className="w-4 h-4" />
              </div>
              {idx < 6 && (
                <div className={`w-0.5 flex-1 mt-1 min-h-[24px] ${isComplete ? "bg-[#0A2540]" : "bg-slate-200"}`}></div>
              )}
            </div>
            <div className="flex-1 pt-1">
              <div className={`font-medium text-sm ${isComplete ? "text-[#0A2540]" : "text-slate-400"}`}>{stage.label}</div>
              <div className="text-xs text-[#475569] mt-0.5">{event?.note || stage.desc}</div>
              {event && (
                <div className="text-xs text-[#94A3B8] mt-1">{new Date(event.timestamp).toLocaleString()}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
